import gql from 'graphql-tag';
import { adFileFragment } from './AdFile';
import { fileFragment } from './File';
export const teamAdAllocationFragment = gql `
  fragment TeamAdAllocation on EntityAdAllocation {
    id
    entityId
    entity {
      ... on Team {
        id
        sport {
          id
          name
        }
      }
      ... on Competition {
        id
        sport {
          id
          name
        }
      }
    }
    adSets {
      adSetAllocations {
        id
        percentage
        events
        entityAdAllocationId
      }
      id
      name
      adFiles {
        ...AdFile
      }
      teamId
    }
  }
  ${adFileFragment}
  ${fileFragment}
`;
//# sourceMappingURL=TeamAdAllocation.js.map